module.exports = __webpack_public_path__ + "img/rm_1.a8ea4f46.png";